export default {
  FILES_LIST: "Files list",
  ADD_FILE: "Add file",
  ADD_FILES: "Add files",
  FILE_ADDED: "File added",
  EDIT_FILE: "Edit file",
  FILE_UPDATED: "File updated",
  DELETE_FILE: "Delete file",
  DELETE_THIS_FILE: "Delete this file?",
  FILE_DELETED: "File deleted",
  FILE_TYPE: "File type",
  CHOOSE_FILE: "Choose file",
  DROP_FILES_HERE: "Drop files here or click to choose them",
  SIZE: "Size",
  DOWNLOAD: "Download",
  OBJECT: "Linked object",
  ALL_OBJECTS: "All linked objects",
  NEW_FOLDER: "New folder",
  NEW_FILE: "New file",
  COPY: "Copy",
  MOVE: "Move",
  REMOVE: "Remove",
  ADD_FOLDER: "Add folder",
  FOLDER_ADDED: "Folder added",
  FOLDER_UPDATED: "Folder updated",
  EDIT: "Edit",
  EDIT_FOLDER: "Edit folder",
  DELETE_THIS_ITEM: "Delete these items?",
  UPLOAD: "Upload",
  SHARE: "Restrictions",
  FOLDER: "Folder",
  FILE: "File",
  FILE_HISTORY: "File history",
  HISTORY: "History",
  FOLDER_EXISTS_WITH_SAME_NAME: "A folder already exists with this name",
  FILE_EXISTS_WITH_SAME_NAME: "A file already exists with this name",
  FILE_EXISTS_WITH_SAME_NAME_X: "A file already exists with this name {filename}",
  OPEN_LOCATION: "Open location",
};
